export default "__VITE_ASSET__DCenhVsJ__"